import {
  FormControl as ChakraFormControl,
  FormErrorMessage as ChakraFormErrorMessage,
  Box,
  type StyleProps,
} from "@chakra-ui/react";

export function Form({
  children,
  ...rest
}: {
  children: React.ReactNode;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
} & StyleProps) {
  return (
    <Box as="form" {...rest}>
      {children}
    </Box>
  );
}

Form.Field = ChakraFormControl;
Form.ErrorMessage = ChakraFormErrorMessage;
